import React from "react";

export default function WavingFlag({ width = 150 }) {
  const slices = 22;
  const poleW = 4;
  const h = Math.round(width * 0.62);
  const flagW = width - poleW;
  return (
    <div className="relative select-none pointer-events-none" style={{ width, height: Math.round(h * 1.2) }} data-testid="waving-flag" aria-hidden="true">
      <div className="absolute rounded-full" style={{ left: 0, top: 0, width: poleW, height: Math.round(h * 1.2), background: "linear-gradient(to bottom,#b45309,#78350f)" }} />
      <div className="absolute rounded-full bg-amber-600" style={{ left: -2, top: -4, width: poleW + 4, height: 8 }} />
      {Array.from({ length: slices }).map((_, i) => (
        <div
          key={i}
          className="absolute flag-slice"
          style={{
            left: poleW + (i * flagW) / slices,
            top: Math.round(h * 0.08),
            width: flagW / slices + 0.6,
            height: h,
            background: "linear-gradient(to bottom, #FF9933 0%, #FF9933 33.4%, #FFFFFF 33.4%, #FFFFFF 66.7%, #138808 66.7%, #138808 100%)",
            borderRadius: i === slices - 1 ? "0 3px 3px 0" : 0,
            boxShadow: i === 0 ? "2px 2px 6px rgba(0,0,0,0.08)" : "none",
            animation: `flagWave 1.7s ease-in-out ${(i * 0.07).toFixed(2)}s infinite`,
          }}
        />
      ))}
      <div
        className="absolute flag-slice rounded-full"
        style={{
          width: Math.round(h * 0.26),
          height: Math.round(h * 0.26),
          left: poleW + flagW / 2 - Math.round(h * 0.13),
          top: Math.round(h * 0.08) + h / 2 - Math.round(h * 0.13),
          border: "2px solid rgba(0,51,102,0.75)",
          background: "radial-gradient(circle, rgba(0,51,102,0.75) 18%, transparent 20%)",
          animation: "flagWave 1.7s ease-in-out 0.77s infinite",
        }}
      />
    </div>
  );
}
